import {FC} from 'react';

import {ReportMasterCounter} from '../../components/Reports/report/ReportMasterCounter';

const MasterCounterPage: FC = () => {
  return (
    <div>
      <ReportMasterCounter />
    </div>
  );
};

export default MasterCounterPage;
